import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const RosterPage = lazy(() => import('@/features/leave/roster/page'));
const FormerRosterPage = lazy(() => import('@/features/leave/former/page'));
const WorkerPage = lazy(() => import('@/features/leave/worker/page'));
const ConfigPage = lazy(() => import('@/features/leave/config/page'));
const InboxPage = lazy(() => import('@/features/leave/inbox/page'));

export const leaveRoutes: RouteObject[] = [
  { path: 'leave', element: <RosterPage /> },
  { path: 'leave/inbox', element: <InboxPage /> },
  { path: 'leave/former', element: <FormerRosterPage /> },
  { path: 'leave/config', element: <ConfigPage /> },
  { path: 'leave/workers/:id', element: <WorkerPage /> },
];
